import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'


const reloadClzName = obj => new Promise((resolve, reject) => {
    const {
        reloadForm,
        token
    } = obj;
    request({
        url: apis.beasts_reload_config + '?token=' + token,
        data: reloadForm
    }).then(res => {
        resolve(res);
    })
});

export default {
    reloadClzName
}



// WEBPACK FOOTER //
// ./src/service/beasts_api.js